import { TABLE_FRESH_HOURLY_OOS, TABLE_FRESH_HOURLY_OOS_L7D, TABLE_FRESH_HOURLY_OOS_L30D, TABLE_FRESH_HOURLY_OOS_YTD } from "./constant";


export const dashboardName = 'Fresh Hourly Out-of-Stock';
export const DASHBOARD_PATH = 'markets-dashboard/fresh-hourly-oos'

//components
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS = 'overview_fresh_hourly_oos';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_ARTICLE_NUMBER = 'article_number';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_ARTICLE_DESCRIPTION = 'article_description';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_PERCENTAGE = 'overview_fresh_hourly_oos_article_oos_percentage';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_8AM = 'overview_fresh_hourly_oos_8am';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_9AM = 'overview_fresh_hourly_oos_9am';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_10AM = 'overview_fresh_hourly_oos_10am';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_11AM = 'overview_fresh_hourly_oos_11am';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_12PM = 'overview_fresh_hourly_oos_12pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_1PM = 'overview_fresh_hourly_oos_1pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_2PM = 'overview_fresh_hourly_oos_2pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_3PM = 'overview_fresh_hourly_oos_3pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_4PM = 'overview_fresh_hourly_oos_4pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_5PM = 'overview_fresh_hourly_oos_5pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_6PM = 'overview_fresh_hourly_oos_6pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_7PM = 'overview_fresh_hourly_oos_7pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_8PM = 'overview_fresh_hourly_oos_8pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_9PM = 'overview_fresh_hourly_oos_9pm';
export const OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_10PM = 'overview_fresh_hourly_oos_10pm';




export const dashboardDatasource = [
    {
        "table": {
            "name": TABLE_FRESH_HOURLY_OOS,
        },
        "columns": [
            { "name": "tran_date" },
            { "name": "company_id" },
            { "name": "company_name" },
            { "name": "branch_id" },
            { "name": "branch_name" },
            { "name": "region" },
            { "name": "article_number" },
            { "name": "article_description" },
            { "name": "merch_category_code" },
            { "name": "merch_category_description" },
            { "name": "hour_start" },
            { "name": "hour_start_24h" },
            { "name": "sales" },
            { "name": "top50_rank_per_merch_cat" },
        ],
        "data_filter_columns": [
            { name: "company_id", label: "Company ID", type: "string" },
            { name: "region", label: "Region Name", type: "string" },
            { name: "branch_ID", label: "Branch ID", type: "string" },
            { name: "branch_name", label: "Branch Name", type: "string" },
            { name: "merch_category_description", label: "Category Name", type: "string" },
            { name: "top50_rank_per_merch_cat", label: "Top rank SKUs", type: "string" }
        ],
        "views": []
    },
    // {
    //     "table": {
    //         "name": TABLE_FRESH_HOURLY_OOS_L7D,
    //     },
    //     "columns": [
    //         { "name": "tran_date" },
    //         { "name": "company_id" },
    //         { "name": "company_name" },
    //         { "name": "branch_id" },
    //         { "name": "branch_name" },
    //         { "name": "region" },
    //         { "name": "article_number" },
    //         { "name": "article_description" },
    //         { "name": "merch_category_code" },
    //         { "name": "merch_category_description" },
    //         { "name": "hour_start" },
    //         { "name": "hour_start_24h" },
    //         { "name": "sales" },
    //         { "name": "top50_rank_per_merch_cat" },
    //     ],
    //     "data_filter_columns": [
    //         { name: "company_id", label: "Company ID", type: "string" },
    //         { name: "region", label: "Region Name", type: "string" },
    //         { name: "branch_ID", label: "Branch ID", type: "string" },
    //         { name: "branch_name", label: "Branch Name", type: "string" },
    //         { name: "merch_category_description", label: "Category Name", type: "string" },
    //         { name: "top50_rank_per_merch_cat", label: "Top rank SKUs", type: "string" },
    //         { name: "article_number", label: "Article Number", type: "string" },
    //         { name: "article_description", label: "Article Description", type: "string" }
    //     ],
    //     "views": []
    // },
    // {
    //     "table": {
    //         "name": TABLE_FRESH_HOURLY_OOS_L30D,
    //     },
    //     "columns": [
    //         { "name": "tran_date" },
    //         { "name": "company_id" },
    //         { "name": "company_name" },
    //         { "name": "branch_id" },
    //         { "name": "branch_name" },
    //         { "name": "region" },
    //         { "name": "article_number" },
    //         { "name": "article_description" },
    //         { "name": "merch_category_code" },
    //         { "name": "merch_category_description" },
    //         { "name": "hour_start" },
    //         { "name": "hour_start_24h" },
    //         { "name": "sales" },
    //         { "name": "top50_rank_per_merch_cat" },
    //     ],
    //     "data_filter_columns": [
    //         { name: "company_id", label: "Company ID", type: "string" },
    //         { name: "region", label: "Region Name", type: "string" },
    //         { name: "branch_ID", label: "Branch ID", type: "string" },
    //         { name: "branch_name", label: "Branch Name", type: "string" },
    //         { name: "merch_category_description", label: "Category Name", type: "string" },
    //         { name: "top50_rank_per_merch_cat", label: "Top rank SKUs", type: "string" }
    //     ],
    //     "views": []
    // },
    // {
    //     "table": {
    //         "name": TABLE_FRESH_HOURLY_OOS_YTD,
    //     },
    //     "columns": [
    //         { "name": "tran_date" },
    //         { "name": "company_id" },
    //         { "name": "company_name" },
    //         { "name": "branch_id" },
    //         { "name": "branch_name" },
    //         { "name": "region" },
    //         { "name": "article_number" },
    //         { "name": "article_description" },
    //         { "name": "merch_category_code" },
    //         { "name": "merch_category_description" },
    //         { "name": "hour_start" },
    //         { "name": "hour_start_24h" },
    //         { "name": "sales" },
    //         { "name": "top50_rank_per_merch_cat" },
    //     ],
    //     "data_filter_columns": [
    //         { name: "company_id", label: "Company ID", type: "string" },
    //         { name: "region", label: "Region Name", type: "string" },
    //         { name: "branch_ID", label: "Branch ID", type: "string" },
    //         { name: "branch_name", label: "Branch Name", type: "string" },
    //         { name: "merch_category_description", label: "Category Name", type: "string" },
    //         { name: "top50_rank_per_merch_cat", label: "Top rank SKUs", type: "string" }
    //     ],
    //     "views": []
    // },
]


export const dashboardComponents = [
    {
        component: "Fresh Hourly Out-of-Stock",
        id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS,
        // readOnly: true,
        subcomponents: [
            {
                component: "Article No.",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_ARTICLE_NUMBER,
                name: "Article No.",
                // default: false
            },
            {
                component: "Article Description",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_ARTICLE_DESCRIPTION,
                name: "Article Description",
                // default: false
            },
            {
                component: "OOS%",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_PERCENTAGE,
                name: "OOS%",
                // default: false
            },
            {
                component: "8:00 AM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_8AM,
                name: "8:00 AM",
                // default: false
            },
            {
                component: "9:00 AM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_9AM,
                name: "9:00 AM",
                // default: false
            },
            {
                component: "10:00 AM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_10AM,
                name: "10:00 AM",
                // default: false
            },
            {
                component: "11:00 AM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_11AM,
                name: "11:00 AM",
                // default: false
            },
            {
                component: "12:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_12PM,
                name: "12:00 PM",
                // default: false
            },
            {
                component: "1:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_1PM,
                name: "1:00 PM",
                // default: false

            },
            {
                component: "2:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_2PM,
                name: "2:00 PM",
                // default: false

            },
            {
                component: "3:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_3PM,
                name: "3:00 PM",
                // default: false

            },
            {
                component: "4:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_4PM,
                name: "4:00 PM",
                // default: false

            },
            {
                component: "5:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_5PM,
                name: "5:00 PM",
                // default: false
            },
            {
                component: "6:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_6PM,
                name: "6:00 PM",
                // default: false
            },
            {
                component: "7:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_7PM,
                name: "7:00 PM",
                // default: false
            },
            {
                component: "8:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_8PM,
                name: "8:00 PM",
                // default: false
            },
            {
                component: "9:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_9PM,
                name: "9:00 PM",
                // default: false
            },
            {
                component: "10:00 PM",
                id: OVERVIEW_COMPONENT_FRESH_HOURYLY_OOS_10PM,
                name: "10:00 PM",
                // default: false
            }
        ],
    },
]

export const dashboardDefinitions = {
    name: dashboardName,
    data_sources: dashboardDatasource,
    entry_points: [
        DASHBOARD_PATH,
    ],
    owners: [ 
        "mainardjustine.d.anastacio@smretail.com",
    ],
    path: DASHBOARD_PATH,
    components: dashboardComponents
}